import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { AddNewWorkspace, WorkspaceMenu } from '../../components/WorkspaceMenu';
import { useSideMenu } from '../../components/SideMenu/SideMenu.context';
import { useUserData } from '../../context';
import { WorkspaceMenuPopoverProps } from '../../components/WorkspaceMenu/WorkspaceMenu.types';
import { useWorkspaceMenuData } from './useWorkspaceMenuData';
import { StyledPlaceholder, WorkspaceDropdownTriggerWrapper } from './DefaultWorkspaceMenu.style';
import { DefaultWorkspaceTrigger } from './DefaultWorkspaceTrigger';
import { Item } from '@clds/item';
import { messages } from '../../i18n';
import styled from 'styled-components';
import { typography } from '@clds/typography';

const HeaderItem = styled(Item)`
  padding: ${(props) => props.theme.spacing.sm} ${(props) => props.theme.spacing.sm} ${(props) => props.theme.spacing.xs};
  ${typography.xxs.regular};
  cursor: default;
  :hover {
    background: none;
  }
`;

export const DefaultWorkspaceMenu: FC<WorkspaceMenuPopoverProps> = (props) => {
  const { getCustomersList, setSearchTerm, items, currentCustomer, setCurrentCustomerId } = useWorkspaceMenuData();
  const { userData: user } = useUserData();
  const { isSideMenuOpen } = useSideMenu();
  const { formatMessage } = useIntl();
  const [isOpened, setIsOpened] = useState(false);

  const forceCloseWhenSideMenuClosed = (isSideMenuOpen: boolean) => !isSideMenuOpen && setIsOpened(false);

  useEffect(() => {
    forceCloseWhenSideMenuClosed(isSideMenuOpen);
  }, [isSideMenuOpen]);

  useEffect(() => {
    if (isOpened) {
      getCustomersList();
    }
  }, [isOpened, getCustomersList]);

  return (
    <>
      {currentCustomer ? (
        <WorkspaceMenu
          {...props}
          headerItem={<HeaderItem>{formatMessage(messages.workspaceMenuHeader)}</HeaderItem>}
          trigger={
            <WorkspaceDropdownTriggerWrapper>
              <DefaultWorkspaceTrigger customHeight="35px" />
            </WorkspaceDropdownTriggerWrapper>
          }
          items={items}
          defaultSelectedId={currentCustomer.externalId}
          onSelect={setCurrentCustomerId}
          onSearchTermChange={setSearchTerm}
          footerItem={user?.isMasterAdmin && <AddNewWorkspace isMobile={false} closeWorkSpaceMenu={() => setIsOpened(false)} />}
          isOpened={isOpened}
          onOpenedChange={setIsOpened}
        />
      ) : (
        <StyledPlaceholder />
      )}
    </>
  );
};
